module.exports = __webpack_public_path__ + "static/img/grade_11.69a9bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_11.png
// module id = dtc/
// module chunks = 89